/**
 * La connexion Google n'est proposée que sur les domaines Web-atrio
 * (team-plus.web-atrio.com et ses variantes). Partout ailleurs (mokahplus.com,
 * local…) : email / mot de passe ou code.
 */
export const GOOGLE_SIGN_IN_DOMAIN = 'web-atrio.com';

export function isGoogleSignInHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === GOOGLE_SIGN_IN_DOMAIN || host.endsWith('.' + GOOGLE_SIGN_IN_DOMAIN);
}
